/**
 * @generated SignedSource<<5a9372be7dfd007194dd4f47fa56fa08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteFolderPayload",
    "kind": "LinkedField",
    "name": "deleteFolder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InboxQuery_deleteFolderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InboxQuery_deleteFolderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b787b40e87d12eae44623335689b1272",
    "id": null,
    "metadata": {},
    "name": "InboxQuery_deleteFolderMutation",
    "operationKind": "mutation",
    "text": "mutation InboxQuery_deleteFolderMutation(\n  $input: DeleteFolderInput!\n) {\n  deleteFolder(input: $input) {\n    clientMutationId\n    ok\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

node.hash = "796cedcd69ee4e983ed95a07b0597408";

module.exports = node;
